import React from 'react';

import { Web } from './Web';
import { Mobile } from './Mobile';

type AddCouponResponsiveOverlayErrorProps = {
  type: 'WEB' | 'MOBILE'
}

export function AddCouponResponsiveOverlayError({
  type
}: AddCouponResponsiveOverlayErrorProps) {
  return (
    type === 'WEB' ? (
      <Web />
    ) : (
      <Mobile />
    )
  );
}